import { useTranslation } from '@wix/fe-essentials-standalone/i18n';
import { Text } from '@wix/design-system';
import { EmptyStateBanner } from '../EmptyStateBanner';
import { EmptyStateBannerProps } from '../EmptyStateBanner/EmptyStateBanner';
import { useEffect } from 'react';
import { useTemplatesBi } from '@components/Hooks/useTemplatesBi';

export const NoFilterResultsBanner = (
  props: Omit<EmptyStateBannerProps, 'title' | 'children'>,
) => {
  const { t } = useTranslation();
  const { logBiPageView } = useTemplatesBi({});

  const titleText = t(
    'marketplace.templates-page.empty-state.filter-no-matches-title',
  );

  useEffect(() => {
    logBiPageView({ message_text: titleText });
  }, []);

  return (
    <EmptyStateBanner title={titleText} {...props}>
      <Text size="medium" weight="thin" secondary>
        {t('marketplace.templates-page.empty-state.filter-no-matches-subtitle')}
      </Text>
    </EmptyStateBanner>
  );
};
